import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';

const contacts = accountId => ({
  parentNav: 'contacts',
  routes: [
    'contacts_dashboard',
    'contact_profile_dashboard',
    'contacts_segments_dashboard',
    'contacts_labels_dashboard',
    'contacts_portfolio',
    'contacts_portfolio_distribution',
    'contacts_assignment_rules',
    'companies_dashboard_index',
    'companies_dashboard_show',
  ],
  menuItems: [
    {
      icon: 'contact-card-group',
      label: 'ALL_CONTACTS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/contacts`),
      toStateName: 'contacts_dashboard',
    },
    {
      icon: 'i-lucide-building-2',
      label: 'COMPANIES',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.COMPANIES,
      toState: frontendURL(`accounts/${accountId}/companies`),
      toStateName: 'companies_dashboard_index',
    },
    {
      icon: 'people-team',
      label: 'CARTEIRIZACAO',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/contacts/portfolio`),
      toStateName: 'contacts_portfolio',
    },
    {
      icon: 'chart-multiple',
      label: 'PORTFOLIO_DISTRIBUTION',
      hasSubMenu: false,
      toState: frontendURL(
        `accounts/${accountId}/contacts/portfolio/distribution`
      ),
      toStateName: 'contacts_portfolio_distribution',
    },
    {
      icon: 'automation',
      label: 'ASSIGNMENT_RULES',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/contacts/assignment-rules`),
      toStateName: 'contacts_assignment_rules',
    },
  ],
});

export default contacts;
